<template>
<BaseModal :config="FootnotesModalLabel" @ResetFields="resetFields" @SaveChanges="saveChanges">
    <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
        <form ref="refFootnotesForm" id="FootnotesForm" action>
            <div id="pageErrors"
				     class="alert alert-danger"
				     v-if="pageErrors.length>0">
					<p>
						<b>Please correct the following error(s):</b>
						<ul>
							<li v-for="error in pageErrors"
							    :key="error">{{ error }}</li>
						</ul>
					</p>
				</div>
            <input type="text" id="txtCommitmentsFunded" readonly v-model="FootnotesInfo.FootnoteID" class="form-control" placeholder="Footnote Id">
            <br/>
            <textarea class="form-control" rows="4" cols="50" id="Footnote" placeholder="Footnote" v-model="FootnotesInfo.Footnote"></textarea>
        </form>
    </div>
</BaseModal>
</template>

<script>
import BaseModal from "@/components/base/BaseModal.vue";
import funcUtil from "@/services/funcUtil.js";
import BaseModelFootnote from "@/models/BaseModelFootnote.js";
import { mapActions } from 'vuex';

export default {
    name: "FootnotesForm",
    components: {
        BaseModal
    },
    mixins: [funcUtil],
    props: {
        FootnotesInfo: {},
        FootnotesModalLabel: {},
        FootnotesClassJsonData: {}
    },
    data: function () {
        return {
            GridConfig: BaseModelFootnote,
            pageErrors : [],
        };
    },
    methods: {
        ...mapActions("postModule", ['UpdateItems', 'CreateItems']),
        resetFields(e) {

        },
        saveChanges(e) {
            let self = this;
            if(self.Validate()){
            if (this.FootnotesModalLabel.modalAddorEdit == "add") {
                let addFormValues = self.FootnotesInfo;
                addFormValues.Footnote = addFormValues.Footnote;
                addFormValues.FootnoteID = addFormValues.FootnoteID;
                let createItem = {
                    list: self.GridConfig,
                    payload: addFormValues
                };
                //let loader = self.$loading.show();
                self._APICrudPopup("APICrudpopup");
                self.CreateItems(createItem).then((res) => {
                    $("#FootnoteGrid")
                        .data()
                        .kendoGrid.dataSource.read();
                    self._AlertPopup("Data Saved Successfully!", "success");
                    self.resetFields();
                }).catch(error=>{
                    self._AlertPopup("Some Error Occurred!","info");
                }).finally(()=>{
                    //loader.hide();
                })
            } else {
                var editFormValues = self.FootnotesInfo;
                editFormValues.Footnote = editFormValues.Footnote;
                editFormValues.FootnoteID = editFormValues.FootnoteID;
                let updateItem = {
                    list: self.GridConfig,
                    payload: editFormValues
                };
                self._APICrudPopup("APICrudpopup");
                //let loader = self.$loading.show();
                self.UpdateItems(updateItem).then((res) => {
                    //loader.hide();
                    $("#FootnoteGrid")
                        .data()
                        .kendoGrid.dataSource.read();
                    self._AlertPopup("Data Updated Successfully!", "success");
                    self.resetFields();
                }).catch(error=>{
                    self._AlertPopup("Some Error Occurred!","info");
                }).finally(()=>{
                    //loader.hide();
                })
            }
                $("#BaseModal").modal("toggle");
                this.pageErrors=[];
            }
        },
    Validate(){
      const self=this;
      self.pageErrors = [];
      let form=self.FootnotesInfo;
      //Form Validations
      if (!(form.Footnote)) {
        self.pageErrors.push("FootNote text is required");
      }
    if (self._validateSpecialCharacter(form.Footnote,"multiline")) {
        self.pageErrors.push(`FootNote Text cannot have ${this.MultiLineSpecialChars}  Characters`);
      }

      return self.pageErrors.length>0 ? false:true
    },
    }
};
</script>

<style>
</style>
